import { Navigate } from 'react-router-dom';

export function DefaultRoute() {
  return <Navigate to="/tenants-admin" replace />;
}
